

import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { visuallyHidden } from '@mui/utils';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import DynamicMantle from './mantles/DynamicMantle';
import { GlobalTheme } from './../theme';
import { Container, Typography, Box, Grid, Card, Button, TextField, Menu, MenuItem, Tooltip, List, ListItem } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import axios from 'axios';
import {
    FilterAltOutlined as FilterAltOutlinedIcon,
    ArrowUpwardOutlined as ArrowUpwardOutlinedIcon,
    ArrowDownwardOutlined as ArrowDownwardOutlinedIcon,
    VerifiedOutlined as VerifiedOutlinedIcon
} from '@mui/icons-material';
import Pagination from '@mui/material/Pagination';

import { alpha, Stack } from '@mui/system';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import CardMedia from '@mui/material/CardMedia';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import HomeMantle from './../components/mantles/mantle';
import { common } from '@mui/material/colors';

const BASE_MEDIA_URL = 'https://aaryanholidays.in/express/uploads/';

export default function SearchResultPage() {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [openFilter, openFilterMenu] = React.useState(null);
    const open = Boolean(openFilter);
    const [tour, setTourDetails] = useState(null);
    const query = new URLSearchParams(location.search);
    //const keywords = query.get('keywords');
    const { keywords } = useParams();
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const videoRefs = useRef([]);
      const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 5;
    const navigate = useNavigate();
    const handleMouseEnter = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && videoElement.paused) {
            videoElement.play().catch(error => console.error('Error playing video:', error));
        }
    };
    const handleMinPriceChange = (e) => {
        setMinPrice(e.target.value);
    };

    const handleMaxPriceChange = (e) => {
        setMaxPrice(e.target.value);
    };
    const handleMouseLeave = (index) => {
        const videoElement = videoRefs.current[index];
        if (videoElement && !videoElement.paused) {
            videoElement.pause();
            videoElement.currentTime = 0;
        }
    };
    const handleCardClick = (id, continent, country, tour) => {
        navigate(`/${continent}/${country}/${tour}/itenary/${id}`);
    };
    const handleFliterMenuOpen = (event) => {
        openFilterMenu(event.currentTarget);
    };
    const handleFliterMenuClose = () => {
        openFilterMenu(null);
    };
    const filteredResults = results.filter(tour => {
        const price = parseFloat(tour.price);
        const min = parseFloat(minPrice);
        const max = parseFloat(maxPrice);

        // If both min and max are set
        if (!isNaN(min) && !isNaN(max)) {
            return price >= min && price <= max;
        }

        // If only min is set
        if (!isNaN(min)) {
            return price >= min;
        }

        // If only max is set
        if (!isNaN(max)) {
            return price <= max;
        }

        // If none are set, return all
        return true;
    });
   const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentResults = filteredResults.slice(indexOfFirstItem, indexOfLastItem);
    const sortResults = (type) => {
        const sortedResults = [...results];
        switch(type) {
            case 'low':
                sortedResults.sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
                break;
            case 'high':
                sortedResults.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
                break;
            case 'latest':
                sortedResults.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
                break;
            default:
                break;
        }
        setResults(sortedResults);
    };

    const sortOptions = [
        { label: "Low to high", icon: <ArrowUpwardOutlinedIcon sx={{ pr: 1 }} />, onClick: () => sortResults('low') },
        { label: "High to low", icon: <ArrowDownwardOutlinedIcon sx={{ pr: 1 }} />, onClick: () => sortResults('high') },
        { label: "Latest", icon: <VerifiedOutlinedIcon sx={{ pr: 1 }} />, onClick: () => sortResults('latest') },
    ];

    // Base JSON data
    const monthsData = [
        { id: 1, title: 'January', initial: 'J' },
        { id: 2, title: 'February', initial: 'F' },
        { id: 3, title: 'March', initial: 'M' },
        { id: 4, title: 'April', initial: 'A' },
        { id: 5, title: 'May', initial: 'M' },
        { id: 6, title: 'June', initial: 'J' },
        { id: 7, title: 'July', initial: 'J' },
        { id: 8, title: 'August', initial: 'A' },
        { id: 9, title: 'September', initial: 'S' },
        { id: 10, title: 'October', initial: 'O' },
        { id: 11, title: 'November', initial: 'N' },
        { id: 12, title: 'December', initial: 'D' },
    ];

    const truemonth = tour?.best_time_to_visit || '';
    const truemonthArray = truemonth.split(',').map(month => month.trim());

    // Create new array with `best` property
    const bestTimeToVisit = monthsData.map(month => ({
        ...month,
        best: truemonthArray.includes(month.title),
    }));


    useEffect(() => {
        setCurrentPage(1)
        if (keywords) {
            const fetchResults = async () => {
                if (keywords == "TrendingPackage") {


                    try {

                        const destinationsResponse = await fetch('https://aaryanholidays.in/frontend/alldestinations');
                        const destinationsData = await destinationsResponse.json();
                        const promotedData = destinationsData.filter(destination => destination.promote === 1);
                        setTourDetails(promotedData);
                        setResults(promotedData);

                        
                    } catch (error) {
                        console.error('Error fetching search results:', error);
                    } finally {
                        setLoading(false);
                    }

                }
                 else if (keywords == "ExploreMore") {


                    try {

                        const destinationsResponse = await fetch('https://aaryanholidays.in/frontend/alldestinations');
                        const destinationsData = await destinationsResponse.json();
                        const promotedData = destinationsData.filter(destination => destination.is_explore_more === 1);
                        setTourDetails(promotedData);
                        setResults(promotedData);

                        
                    } catch (error) {
                        console.error('Error fetching search results:', error);
                    } finally {
                        setLoading(false);
                    }

                }
                else {
                    try {
                        const response = await fetch(`https://aaryanholidays.in/frontend/search-destinations?keywords=${encodeURIComponent(keywords)}`);
                        // console.error(`https://aaryanholidays.in/frontend/search-destinations?keywords=${encodeURIComponent(keywords)}`);
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        const data = await response.json();
                        setTourDetails(data);
                        setResults(data);
                        const filteredResults = results.filter(tour => {
                            const price = parseFloat(tour.price);
                            const min = parseFloat(minPrice);
                            const max = parseFloat(maxPrice);

                            // If both min and max are set
                            if (!isNaN(min) && !isNaN(max)) {
                                return price >= min && price <= max;
                            }

                            // If only min is set
                            if (!isNaN(min)) {
                                return price >= min;
                            }

                            // If only max is set
                            if (!isNaN(max)) {
                                return price <= max;
                            }

                            // If none are set, return all
                            return true;
                        });
                    } catch (error) {
                        console.error('Error fetching search results:', error);
                    } finally {
                        setLoading(false);
                    }
                }


            };

            fetchResults();
        }
    }, [keywords,maxPrice, minPrice]);
    const [bannerImage, setBannerImage] = useState(null);

    useEffect(() => {
        const fetchDiscovery = async () => {
            try {
                const res = await axios.get('https://aaryanholidays.in/backend/table-data/aaryan_discovery');
                const data = res.data.data;

                const match = data.find(
                    item => item.discovery.replace(/<[^>]+>/g, '') === decodeURIComponent(keywords)
                );

                if (match?.image_banner_image) {
                    setBannerImage(`${BASE_MEDIA_URL}${match.image_banner_image}`);
                }
                else {
                    setBannerImage(`${BASE_MEDIA_URL}searchBanner1.jpeg`);
                }
            } catch (error) {
                console.error('Error fetching discovery data:', error);
            }
        };

        fetchDiscovery();
    }, [keywords]);

    return (
        <React.Fragment>
            <ThemeProvider theme={GlobalTheme}>
                <CssBaseline />
                {/* <HomeMantle home={1} /> 
                 <DynamicMantle
                    banner_type={tourTypeData.banner_type}
                    banner_src={`${BASE_MEDIA_URL}${tourTypeData.banner_src}`}
                    banner_alt={tourTypeData.banner_alt}
                    banner_title={tourTypeData.banner_title}
                    banner_description={tourTypeData.banner_description}
                /> */}
                <Box position='relative'>
                    <Box position='absolute' display='flex' alignItems='center' justifyContent='center' width='100%' height='100%' textAlign='center'>

                        <Typography id="destinationHeading" component='h1' variant='h1' sx={{ mb: 2 }}>
                            <Typography component='span' variant='subtitle2' sx={{ display: 'block', width: '100%' }} fontWeight='400' gutterBottom>Search result for</Typography>
                            {keywords}
                        </Typography>

                    </Box>
                    <CardMedia
                        component="img"
                        height="500"
                        image={bannerImage || `${BASE_MEDIA_URL}searchBanner1.jpeg`}
                        alt=""
                    />
                </Box>
                <Container fluid sx={{ py: 5 }}>
                    {loading ? (
                        <Typography>Loading...</Typography>
                    ) : results.length === 0 ? (
                        <Typography>No results found</Typography>
                    ) : (
                        <>
                            <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>

                                <Box sx={{ display: 'flex', alignItems: 'flex-end', width: 200, mr: 2 }}>
                                    <TextField
                                        id="minBudget"
                                        type='number'
                                        label="Min"
                                        variant="outlined"
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                py: .9,
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><Typography sx={{ fontWeight: 600 }}>INR</Typography></InputAdornment>,
                                        }}
                                         value={minPrice}
                                         onChange={handleMinPriceChange}
                                    />
                                    {/* <TextField id="minBudget" type='number' label="Min" variant="standard" inputProps={{ min: 0 }} /> */}
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'flex-end', width: 200, mr: 2 }}>

                                    {/* <TextField id="maxBudget" type='number' label="Max" variant="standard" inputProps={{ min: 0 }} /> */}
                                    <TextField
                                        id="maxBudget"
                                        type='number'
                                        label="Max"
                                        variant="outlined"
                                        sx={{
                                            '& .MuiInputBase-input': {
                                                py: .9,
                                            },
                                        }}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start"><Typography sx={{ fontWeight: 600 }}>INR</Typography></InputAdornment>,
                                        }}
                                        value={maxPrice}
                                        onChange={handleMaxPriceChange}
                                    />

                                </Box>

                                <Button
                                    id="btnFilter" variant='outlined'
                                    aria-controls={open ? 'btnFilterMenu' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={handleFliterMenuOpen} disableFocusRipple
                                    sx={{
                                        px: 4
                                    }}
                                >
                                    Filter
                                </Button>
                                <Menu
                                    id="btnFilterMenu"
                                    anchorEl={openFilter}
                                    open={open}
                                    onClose={handleFliterMenuClose}
                                    MenuListProps={{
                                        'aria-labelledby': 'btnFilter',
                                    }}
                                >
                                    {sortOptions.map((option, index) => (
                                        <MenuItem
                                            key={index}
                                            onClick={() => {
                                                option.onClick(); // Execute the specific function
                                                handleFliterMenuClose(); // Close the menu after selection
                                            }}
                                        >
                                            {option.icon} {option.label}
                                        </MenuItem>
                                    ))}
                                </Menu>
                            </Box>
                            <Grid container id='tourListing' sx={{ mt: 2, mb: { md: 4 } }}>
                                {currentResults.map((tour, index) => (
                                    <Grid
                                        item
                                        id={`tourListing${tour.id}`}
                                        key={tour.id}
                                        xs={12}
                                        sm={6}
                                        md={12}

                                        sx={{
                                            display: 'inline-flex',
                                            border: { md: `1px solid ${GlobalTheme.palette.common.grayDark}` },
                                            p: 0,
                                            mb: { xs: 4, md: 7 },
                                            borderRadius: 2.5,
                                            backgroundColor: alpha(GlobalTheme.palette.primary.main, .02)
                                        }}
                                    >
                                        <Grid container spacing={4} m={0} sx={{
                                            '& .MuiGrid-item': {
                                                p: 0
                                            }
                                        }}>

                                            <Grid item xs={12} md={3}>
                                                <Card
                                                    sx={{
                                                        position: 'relative',
                                                        borderTopLeftRadius: 8,
                                                        borderBottomLeftRadius: 8,
                                                        borderTopRightRadius: 0,
                                                        borderBottomRightRadius: 0,
                                                        height: 348,
                                                        overflow: 'hidden'
                                                    }}>


                                                    {tour.type === 'video' ? (
                                                        <CardMedia
                                                            id={`destinationThumbsVid${index}`}
                                                            component="video"
                                                            src={`${BASE_MEDIA_URL}${tour.src}`}
                                                            loop
                                                            muted
                                                            playsInline
                                                            ref={(el) => (videoRefs.current[index] = el)}
                                                        >
                                                            <source src={`${BASE_MEDIA_URL}${tour.src}`} type="video/mp4" />
                                                            Your browser does not support the video tag.
                                                        </CardMedia>
                                                    ) : (
                                                        <CardMedia
                                                            id={`destinationThumbsImg${index}`}
                                                            component="img"
                                                            src={`${BASE_MEDIA_URL}${tour.src}`}
                                                            alt={tour.alt}
                                                            sx={{
                                                                height: '100%',

                                                            }}
                                                        />
                                                    )}
                                                </Card>
                                            </Grid>
                                            <Grid id={`grd${index}`} item xs={12} md={9} sx={{
                                                "&.MuiGrid-item": {
                                                    py: 2, px: 4
                                                },
                                                display: 'flex', flexWrap: 'wrap', flexDirection: 'column', justifyContent: 'space-between'
                                            }}>
                                                <Box>
                                                    <Stack direction='row' display='flex' justifyContent='space-between' sx={{ mb: 1 }}>
                                                        <Stack>
                                                            <Button variant='text' sx={{
                                                                p: 0,
                                                                width: '100%', textAlign: 'left', justifyContent: 'flex-start', textDecoration: 'underline', color: GlobalTheme.palette.common.black,
                                                                '&:hover': {
                                                                    color: 'inherit',
                                                                    backgroundColor: 'transparent',
                                                                    textDecoration: 'underline',

                                                                }
                                                            }} onClick={() => handleCardClick(tour.id, tour.continent_name.replace(/\s+/g, '-'), tour.tour_type_name.replace(/\s+/g, '-'), tour.thumbnail_heading.replace(/\s+/g, '-'))}

                                                            >
                                                                <Typography variant='h2' component='h3' sx={{ color: GlobalTheme.palette.common.black }} gutterBottom>
                                                                    <span dangerouslySetInnerHTML={{ __html: tour.thumbnail_heading }} />
                                                                </Typography>
                                                            </Button>
                                                            <Typography variant='subtitle1' component='p' fontWeight='600' sx={{ color: GlobalTheme.palette.common.black }}>
                                                                {tour.tour_days}
                                                            </Typography>
                                                            <Typography variant="body2" sx={{ color: GlobalTheme.palette.common.bodyTxt }} marginBottom={2}>
                                                                {tour.banner_description}
                                                            </Typography>
                                                        </Stack>
                                                        <Typography variant="body2" sx={{
                                                            color: GlobalTheme.palette.common.bodyTxt,
                                                            display: 'flex', alignItems: 'flex-start',
                                                        }}>
                                                            <Typography component='span' variant='h2' sx={{
                                                                color: GlobalTheme.palette.primary.main,
                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                            }}>
                                                                <Typography component='span' variant='h3'>INR&nbsp;</Typography>
                                                                {/* <CurrencyRupeeIcon fontSize='medium' /> */}
                                                                {tour.price}</Typography>
                                                        </Typography>
                                                    </Stack>


                                                </Box>

                                                <Stack direction={{ xs: 'çolumn', md: 'row' }} display='flex' justifyContent='space-between' alignItems='flex-end'>
                                                    <Grid item xs={12} lg={9}>
                                                        <Typography variant="body2" component='span' sx={{ color: GlobalTheme.palette.common.bodyTxt }}>
                                                            <Typography component='p' fontWeight={600} color={common.black}>Best time to visit</Typography>
                                                            <List
                                                                sx={{
                                                                    display: 'inline-flex',
                                                                    flexWrap: 'wrap',
                                                                    mt: 1
                                                                }}>

                                                                {(() => {
                                                                    const truemonth = tour.location || '';
                                                                    const truemonthArray = truemonth.split(',').map(month => month.trim());
                                                                    const bestTimeToVisit = monthsData.map(month => ({
                                                                        ...month,
                                                                        best: truemonthArray.includes(month.title),
                                                                    }));

                                                                    return bestTimeToVisit.map(month => (
                                                                        <Tooltip title={month.title} key={month.id}>
                                                                            <ListItem
                                                                                sx={{
                                                                                    mr: 2,
                                                                                    fontSize: GlobalTheme.typography.subtitle2.fontSize,
                                                                                    backgroundColor: month.best ? GlobalTheme.palette.primary.main : GlobalTheme.palette.common.white,
                                                                                    border: '1px solid',
                                                                                    borderColor: month.best ? GlobalTheme.palette.primary.white : GlobalTheme.palette.common.grayDark,
                                                                                    color: month.best ? GlobalTheme.palette.common.white : GlobalTheme.palette.common.bodyTxt,
                                                                                    borderRadius: 50,
                                                                                    mb: 2, p: 0, justifyContent: 'center', alignItems: 'center', display: 'flex',
                                                                                    width: 30, height: 30,
                                                                                    '&:after': {
                                                                                        content: month.best ? 'none' : "''",
                                                                                        position: 'absolute',
                                                                                        width: '100%',
                                                                                        height: 2,
                                                                                        backgroundColor: month.best ? '' : GlobalTheme.palette.common.tertiary,
                                                                                        opacity: .3,
                                                                                        transform: 'rotate(300deg)',
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {month.initial}
                                                                            </ListItem>
                                                                        </Tooltip>
                                                                    ));
                                                                })()}
                                                            </List>
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} lg={3} display='flex' justifyContent={{ xs: 'center', md: 'flex-end' }} sx={{ width: '100%' }}>
                                                        <Button id={'destinationListing' + tour.id} variant="outlined"
                                                            sx={{
                                                                color: GlobalTheme.palette.common.black, borderColor: GlobalTheme.palette.common.black,
                                                                fontWeight: 600, borderRadius: 2.5,
                                                                pl: 5,
                                                                mb: {
                                                                    sm: 2, md: 2
                                                                },
                                                                overflow: 'hidden', // Ensures no overflow on hover
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                transition: 'transform 0.3s ease',

                                                                '&:hover .icon': {
                                                                    opacity: 1,
                                                                    transform: 'translateX(10px)', // Slide icon in from the left
                                                                },
                                                            }}

                                                            onClick={() => handleCardClick(tour.id, tour.continent_name.replace(/\s+/g, '-'), tour.tour_type_name.replace(/\s+/g, '-'), tour.thumbnail_heading.replace(/\s+/g, '-'))}

                                                        >
                                                            <Box
                                                                className="buttonContent"
                                                                sx={{
                                                                    display: 'flex',
                                                                    alignItems: 'center', justifyContent: 'center',
                                                                    transition: 'transform 0.3s ease',
                                                                }}
                                                            >
                                                                <Box component='span'>Explore Now</Box>
                                                                <KeyboardArrowRightOutlinedIcon
                                                                    className="icon"
                                                                    sx={{
                                                                        ml: 1, // Add some spacing between text and icon
                                                                        opacity: 0,
                                                                        transform: 'translateX(0)', // Initial position off to the left
                                                                        transition: 'opacity 0.3s ease, transform 0.3s ease', // Smooth transition for appearance
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Button>
                                                    </Grid>
                                                </Stack>
                                            </Grid>

                                        </Grid>
                                    </Grid>
                                ))}
                            </Grid>
                             {/* Pagination */}
                            <Box mt={4} display="flex" justifyContent="center">
                                <Pagination
                                    count={Math.ceil(filteredResults.length / itemsPerPage)}
                                    page={currentPage}
                                    onChange={(e, value) => setCurrentPage(value)}
                                    color="primary"
                                    shape="rounded"
                                />
                            </Box>
                        </>
                    )}
                </Container>
            </ThemeProvider >
        </React.Fragment >
    )
}



